import React from "react";

const QuickFacts = ({ facts }) => {
  if (!facts || !facts.length) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 rounded-2xl p-4 md:p-5 w-full h-full flex flex-col justify-between transition-colors duration-300 -ml-1">
      {/* Title */}
      <h2 className="text-lg md:text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4 text-left">
        Quick Facts
      </h2>

      {/* Facts List */}
      <ul className="flex flex-col gap-2.5 flex-1 justify-between">
        {facts.map((item, index) => (
          <li
            key={index}
            className="flex justify-between items-center text-gray-700 dark:text-gray-100 text-sm md:text-base transition-colors duration-300"
          >
            <span className="text-gray-600 dark:text-gray-300 pl-1">
              {item.label}
            </span>
            <span className="text-gray-800 dark:text-gray-100 pr-1 font-medium">
              {item.value}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickFacts;
